/**
 * Created by wzf on 2018/4/23.
 */
export const m = {
    b_newrole: '新增角色',
    t_deleterole: '刪除角色',
    t_updaterole: '編輯角色',
    m_newsucs: '新增成功',
    m_deletesuc: '刪除成功',
    m_info: '信息提示',
    m_accountnumber: '請輸入賬號',
    m_length220: '長度在 2 到 20 個字符',
    m_deleterole: '此操作將永久刪除該角色, 是否繼續?',
    m_jurisdiction: '請至少選擇壹種權限',
    m_updatesucs:'修改成功',
    t_confirm:'確認',
    t_cancel:'取消',
    t_search: '搜索條件',
    t_custcode: '客戶編號',
    t_groupname: '組名',
    t_customergroupname: '客戶組名',
    b_breakrelation: '解除關系',
    b_newmembergrp: '新增客戶組成員',
    m_groupnameinput: '請輸入客戶組名',
    m_customerinput: '請輸入客戶',
    m_deleteconfirmnexus: '此操作將解除與客戶組的關系, 是否繼續?',
    m_removesuc: '關系解除成功',
    t_memberdata: '成員資料',
    m_newmembersuc: '添加成員成功',
    t_memebername: '成員名字',
    b_query: '查詢',
    b_opt: '操作',
    b_edit: '編輯',
    t_nodata: '暫無數據',
    t_customergroup: '客戶組管理',
    t_newcustomergroup: '新增客戶組',
    t_updatecustomergroup: '編輯客戶組',
    t_deletecustomergroup: '刪除客戶組',
    t_customergroupsee: '客戶組詳情',
    t_newproductcode: '新增客戶產品編碼',
    t_updateproductcode: '編輯客戶產品編碼',
    t_deletecustproductc: '刪除客戶產品編碼',
    b_cancel: '取消',
    b_save: '保存',
    m_newsucs: '新增成功',
    m_updatesucs: '修改成功',
    m_deleteconfirm: '此操作將永久刪除該資料, 是否繼續？',
    m_deletesuc: '刪除成功',
    t_customer: '客戶',
    s_login: '用戶名/別名',
    t_login: '用戶名',
    t_enable: '啟用',
    t_stop: '停用',
    t_newTask: '新增任務',
    t_salesName:'銷售員',
    t_taskDate:'任務時間',
    t_booking:'搬遷預訂',
    t_site:'現場調查',
    t_delete:'刪除',
    t_selectthefile: '選擇檔案',
    t_enclosureadmin: '附件管理',
    b_uploadfile: '上傳文件',
    b_uploadfileMaxFiftyMb:'上傳文件不能超過50MB',
    m_uploadsuccess: '上傳成功',
    t_filename: '文件名',
    t_filenameremark: '文件備註',
    t_uploadby: '上傳人',
    t_uploadtime: '上傳時間',
    t_remarks: '備註',
    t_file: '文件',
    t_download: '下載',
    b_delete: '刪除',
    menu_task: '任務資料',
    t_export: "導出",
    t_lastweek: '最近壹周',
    t_lastmonth: '最近壹個月',
    t_lastthreemonth: '最近三個月',
    m_accounting: '會計',
    menu_cust: '客戶報表',
    menu_storIn: '入倉報表',
    menu_storOn:'出倉報表',
    menu_storInOn:'出入倉紀錄表',
    menu_existing:'貨倉現存報表',
    menu_jobNo: '工作單號',
    t_date: '日期',
    t_startdate: '開始日期',
    t_enddate: '結束日期',
    t_quarterDate: '季度',
    t_monthDate: '月份',
    t_yearDate: '年份',
    m_date: '請選擇季度',
    m_monthDate: '請選擇月份',
    m_yearDate: '請選擇年份',
    m_customer: '請選擇客戶',
    t_newFeedBack:'新增回料',
    t_newRolling:'新增出倉',
    m_numbernot0: '數量不能少於0!',
    t_addgoodsadjustment: '新增貨品調整',
    t_editgoodsadjustment: '修改貨品調整',
    t_qtysk: '數量',
    b_prodcode: '產品',
    t_nodata: '暫無數據',
    t_new: '新增',
    m_untreated: '該產品已存在，還未處理',
    m_repeatedselection: '重復選擇產品',
    m_productchoice: '請選擇產品',
    m_number: '請輸入數量',
    m_remarks: '請輸入備註',
    m_newgoodssuc: '新增貨品成功',
    m_lengthmin100: '長度不超過100位',
    m_producttype: '請選擇產品',
    b_import: '導入',
    b_delete: '刪除',
    m_deleteconfirm: '此操作將永久刪除該資料, 是否繼續？',
    m_deletesuc: '刪除成功',
    m_Importconfirm: '妳確定要入倉嗎？',
    m_outconfirm: '妳確定要出倉嗎？',
    m_Importsucs:'導入成功',
    t_ExportFormat:'導出格式',
    t_place:'地點',
    m_pleaseSalesName:'請選擇銷售員',
    m_pleasePlace:'請選擇地點',
    m_pleaseStartdate: '請選擇開始時間',
    m_pleaseEnddate: '請選擇結束時間',
    t_calendarStartdate: '開始時間',
    t_calendarEnddate: '結束時間',
    m_startmaxenddate: '開始時間不能大於結束時間',
    m_endminstartdate: '結束時間不能小於開始時間',
    t_downloadPDF: 'PDF下载',
}




// WEBPACK FOOTER //
// ./src/common/lang/tw.js